module.exports = __webpack_public_path__ + "static/menu-Fitness-b0f12fedc37cbc5941fcf4c86ea23fd3.png";